import React from 'react';
import { useDispatch } from 'react-redux';

// Componentes
import ImportButton from './ImportButton.component';

// Estilos
import './Menu.style.scss';

// Redux
import { AddImage, ImageData } from '../../../../Redux/Actions/Atlas/images.action';
import { Observer, GLOBAL_EVENT } from '../../Observer';
import { Link } from 'react-router-dom';
import { ResetAllAnimationAction } from '../../../../Redux/Actions/globals.actions';
import acceptFormatImages from '../../../../constants/acceptFormatImages';
import getGifFrames from '../../../../utils/getGifFrames';

import Patreon from '../../../../Vendor/become_patreon.png';
import isElectron from 'is-electron';

const MenuComponent: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    const receiveImages = (images: ImageData[]) => {
        dispatch(AddImage(images));
    };

    const receiveAtlasImage = (images: ImageData[]) => {
        // Ejeutamos el evento para el atlas ya que se abre el modal que modifica el atlas
        Observer.emit(GLOBAL_EVENT.IMPORT_ATLAS.OPEN_ATLAS_IMPORT, images);
    };

    const receiveGif = async (gif: ImageData[]) => {
        if (gif[0].src?.includes('image/gif')) {
            Observer.emit(GLOBAL_EVENT.SPINNER.OPEN);
            try {
                const all_gifs = await getGifFrames(gif[0].src);
                const gif_object = {
                    name: gif[0].name,
                    width: gif[0].width,
                    height: gif[0].height,
                    srcs: all_gifs,
                };
                Observer.emit(GLOBAL_EVENT.IMPORT_GIF, gif_object);
            } catch (err) {
                Observer.emit(GLOBAL_EVENT.NOTIFICATION_SYSTEM.ERROR, `Gif error`);
            }
            Observer.emit(GLOBAL_EVENT.SPINNER.CLOSE);
        } else {
            Observer.emit(GLOBAL_EVENT.NOTIFICATION_SYSTEM.WARNING, 'It is not a gif file');
        }
    };

    return (
        <nav className="menu noselect">
            <ul>
                <li className="icon">
                    {isElectron() ? (
                        <Link to="/" className="material-icons">
                            home
                        </Link>
                    ) : (
                        <a href="https://gammafp.com" className="material-icons">
                            home
                        </a>
                    )}
                </li>
                <ImportButton
                    loadImages={receiveImages}
                    multiple={true}
                    accept={acceptFormatImages.join(',')}
                >
                    Import
                </ImportButton>
                <ImportButton
                    loadImages={receiveAtlasImage}
                    multiple={false}
                    accept={acceptFormatImages.join(',')}
                >
                    Import Atlas
                </ImportButton>
                <ImportButton loadImages={receiveGif} multiple={false} accept={'image/gif'}>
                    Import Gif
                </ImportButton>
                <li
                    onClick={() => {
                        // ObserverAnim.removeAllListeners();
                        dispatch(ResetAllAnimationAction());
                        Observer.emit(GLOBAL_EVENT.RESET_ATLAS);
                    }}
                >
                    Reset
                </li>
                <li>
                    <a
                        href="https://www.patreon.com/join/gammafp?"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={Patreon} alt="Patreon" />
                    </a>
                </li>
            </ul>
        </nav>
    );
};

export default MenuComponent;
